import { useCallback } from "react"
import { useSelector } from "react-redux"
import type { RootState } from "@/store/store"

interface MainProduct {
  productID?: string | number
  qty: string | number
}

interface AddOnCartItem {
  pid: string | number
  qty: string | number
  from: 0 | 1
}

const toNumber = (value: string | number | undefined | null) => Number(value || 0)

const isSameProduct = (left?: string | number, right?: string | number) => {
  return !!left && !!right && toNumber(left) === toNumber(right)
}

const isMainCartItem = (item: any, mainProduct?: MainProduct) => {
  return (
    isSameProduct(item?.productID, mainProduct?.productID) &&
    toNumber(item?.fromZone) !== 1
  )
}

const isSelectedCartItem = (item: any) => toNumber(item?.appSelectStatus) === 1

export default function useAddOnCartItems(mainProduct?: MainProduct) {
  const availableCartItems = useSelector(
    (state: RootState) => state.cartListSlice.data.available,
  )

  return useCallback(
    (addOnProductID: string | number): AddOnCartItem[] => {
      const addOnCartItem: AddOnCartItem = {
        pid: addOnProductID,
        qty: 1,
        from: 1,
      }

      if (!mainProduct?.productID) return [addOnCartItem]

      const mainCartItem = availableCartItems.find((item: any) =>
        isMainCartItem(item, mainProduct),
      )

      if (mainCartItem && isSelectedCartItem(mainCartItem)) {
        return [addOnCartItem]
      }

      return [
        {
          pid: mainProduct.productID,
          qty: mainProduct.qty,
          from: 0,
        },
        addOnCartItem,
      ]
    },
    [availableCartItems, mainProduct],
  )
}
